import React, { useState, useEffect } from 'react';
import Btn from '../../../../Components/Btn';
import SearchBar from '../../../../Components/SearchBar';
import { EmptyState } from '../../../../Components/EmptyState/EmptyState';
import { PanelBody, PanelSection } from '../../../../Components/Panel/Panel';
import { demoteId, promoteId, pinId } from '../../Ranking/utils';

export default function PanelManualSortingBody({
	searchTerm,
	searchTermForInput,
	handleSearch,
	productList,
	handleAdd,
	handleDeleteAll,
	nbProducts,
	dimension,
}) {

	const [isEmpty, setIsEmpty] = useState(false);
	const [texts, setTexts] = useState({});

	useEffect(() => {
		setIsEmpty(!nbProducts && !searchTerm);
	}, [nbProducts, searchTerm]);

	useEffect(() => {
		switch (dimension) {
			case promoteId:
				setTexts({
					emptyTitle: 'Manually promote product to the top of their categories',
					emptySearchPlaceholder: 'Search for a product to promote',
					addButton: 'Add multiple products'
				});
				break;
			case demoteId:
				setTexts({
					emptyTitle: 'Manually demote product to the end of their categories',
					emptySearchPlaceholder: 'Search for a product to demote',
					addButton: 'Add multiple products'
				});
				break;
			case pinId:
				setTexts({
					emptyTitle: 'Manually pin products in collections',
					emptySearchPlaceholder: 'Search for a product to pin',
					addButton: 'Pin product'
				});
				break;

		}
	}, [dimension]);

	return (
		<>
			{isEmpty &&
				<PanelBody position='relative'>
					<EmptyState
						title={texts.emptyTitle}
						verticalAlign={true}
						primaryAction={
							<>
								<SearchBar
									value={searchTermForInput}
									onChange={handleSearch}
									placeholder={texts.emptySearchPlaceholder}
									fullWidth={false}
									width="xl"
									size="l"
								/>
								{handleAdd &&
									<div className='mt_20'>
										<div className='inline_flex'>
											<span>Or{' '}</span>
											<Btn
												onClick={handleAdd}
												message={texts.addButton}
												color="primary"
												style='link'
											/>
										</div>
									</div>
								}
							</>
						}
					/>
				</PanelBody>
			}
			{!isEmpty &&
				<>
					<PanelSection hasBottomBorder={false}>
						<div className='flex'>
							<div className='flex_item_full'>
								<SearchBar
									value={searchTermForInput}
									onChange={handleSearch}
									placeholder={'Search in product catalog'}
									fullWidth={false}
									width="l"
									autoFocus={true}
								/>
							</div>
							<div className='flex_item_fix ml_20'>
								{handleAdd &&
									<Btn
										onClick={handleAdd}
										icon="fas fa-plus-circle"
										message={texts.addButton}
										color="primary"
										style='reverse'
									/>
								}
								<Btn
									onClick={handleDeleteAll}
									tooltip="Remove all products"
									color="secondary"
									style="outline"
									icon="fas fa-ban"
									horizontalSize="xxs"
								/>
							</div>
						</div>
					</PanelSection>
					<PanelBody hasTopMargin={false} position='relative'>
						{productList}
					</PanelBody>
				</>
			}
		</>
	);
}